export const environment = {
  AuthenticationEnabled: true,
  SSO_ID: 'dfcfab10-ea43-45fc-7ae9-08da99f969ab',
  APP_ID: {
    PORTAL: '3261BDFB-7818-4BC1-9187-E1FA2122ABEA',
    FE: 'EDD6E3EA-C4FC-40A1-AE83-EBE84D339D7E'
  },
  REFRESH_IOC_TIME: 1800000,
  REFRESH_SSO_TIME: 1800000,
  production: true,
  userInfo: 'UserInfo-V1.0.0',
  appVersion: 'v1.0.0',
  IOC_ACCESS_TOKEN_KEY: 'ff9d9e7d-538d-4641-9f09-d82c8b331148',
  IOC_REFRESH_TOKEN_KEY: 'f6f46d70-bea3-40d4-a69b-fe6df7a49db7',
  IOC_EXPIRES_TOKEN_KEY: '2fe88d61-1ac6-4969-9454-2d02e3249b90',
  IOC_SET_INTERVAL_LOGOUT: 'cc1c1b3b-9d2a-4e1f-8a5b-eef750c0638b',
  IOC_KEY_CRYPTO: 'a3744a79467246529c5b3a537e5396e1',
  IOC_IV_CRYPTO: '34edde6e4734479f',
  NKGAUTH_KEY: '3dd08db6-244d-4d68-8a63-000d156af72b',
  WSO2AUTH_KEY: '4472ee69-ef63-4802-bd05-b53fd157baee',
  MENU_KEY: '73af2bfa-b820-424e-8fec-9941a6ee71c4',
  isMockEnabled: false,
  isUsingSSOConfig: false,
  IOC_PAGE_LOCAL: 'https://172.16.70.79:8001',
  IOC_PAGE: 'https://ioc.moet.gov.vn',
  apiUrl: 'https://api-ioc.moet.gov.vn/api',
  apiUrlEoffice: 'https://api-ioc.moet.gov.vn/api',
  //apiUrl: 'https://apidevelop.local/api',
  apiKey: 'pgH7QzFHJx4w46fI~5Uzi4RvtTwlEXp',
  SSO_CONFIG: {
    clientID: 'DNoW4q482RZfMLfzbDfKwN_Nm1sa',
    clientSecret: 'STKI7jOL3g189nul4Bt1gKFRpvUa',
    responseType: 'code',
    scope: ['openid'],
    // redirectUri: 'http://localhost:8080',
    baseUrl: 'https://dangnhap.moet.gov.vn',
    loginUrl: 'oauth2/authorize',
    logoutUrl: 'oidc/logout',
    getTokenUrl: 'oauth2/token',
    revokeTokenUrl: 'oauth2/revoke',
    getUserInfoUrl: 'oauth2/userinfo'
  }
};
